import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const LinkIcon = createIcon({
  displayName: 'LinkIcon',
  path: [
    <path
      d='M16.75 13.25L18 12C19.6569 10.3431 19.6569 7.65684 18 5.99999C16.3431 4.34314 13.6569 4.34314 12 5.99999L10.75 7.24999'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    <path
      d='M7.25 10.75L6 12C4.34315 13.6569 4.34315 16.3431 6 18C7.65685 19.6569 10.3431 19.6569 12 18L13.25 16.75'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />,
    <path
      d='M14.25 9.75L9.75 14.25'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  ],
  defaultProps: defaultProps
})
